import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import PaginationComponent from "../Datatable/Pagination/Index";
import UseFullPageLoader from "../FullPageLoader/UseFullPageLoader";

const MyPostList = () => {
  document.title = "DirtMap - My Posts";

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [postList, setPostList] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const ITEMS_PER_PAGE = 10;
  const [loader, showLoader, hideLoader] = UseFullPageLoader();

  const getMyPosts = async () => {
    try {
      showLoader();

      const userId = localStorage.getItem("user_id");
      if (!userId) {
        swal("Error", "User not logged in", "error");
        history.push("/login");
        return;
      }

      const res = await axios.post(
        "/api/sitepost/user/list",
        { user_id: Number(userId) },
        { headers: { Accept: "application/json" } }
      );

      const result = res.data?.result ?? [];
      setPostList(Array.isArray(result) ? result : []);
      setLoading(false);
    } catch (err) {
      console.error(err);
      swal("Error", err?.response?.data?.message || "Failed to load posts", "error");
      setLoading(false);
    } finally {
      hideLoader();
    }
  };

  // delete post
  const deletePost = (id) => {
    swal({
      title: "Are you sure?",
      text: "This post will be deleted.",
      icon: "warning",
      buttons: ["Cancel", "Yes, Delete"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;

      try {
        showLoader();

        const userId = localStorage.getItem("user_id");

        if (!userId) {
          swal("Error", "User not logged in", "error");
          history.push("/login");
          return;
        }

        const res = await axios.delete(
          `/api/post/site/delete/${id}/${userId}`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (res.data.status_code === 200) {
          swal("Success", res.data.message, "success");

          // Reload user's posts
          getMyPosts();
        } else {
          swal(
            "Error",
            res.data.message || "Delete failed",
            "error"
          );
        }
      } catch (err) {
        console.error(err);

        swal(
          "Error",
          err?.response?.data?.message ||
            "Delete failed",
          "error"
        );
      } finally {
        hideLoader();
      }
    });
  };

  useEffect(() => {
    getMyPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const paginatedData = useMemo(() => {
    const computed = postList || [];
    setTotalItems(computed.length);

    return computed.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [postList, currentPage]);

  if (loading) {
    return (
      <div className="fp-container">
        <img src={"/images/spinner.gif"} className="fp-loader" alt="loading" />
      </div>
    );
  }

  return (
    <>
      <section className="breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12 bread-crumb">
              <Link to="/">Home</Link><span>&gt;</span>My Posts
            </div>
          </div>
        </div>
        <hr />
      </section>

      <section className="contentContainer">
        <div className="container">
          {paginatedData.length === 0 ? (
            <div className="favoritesList shadowBox">
              <div className="row">
                <div className="col-md-12">
                  <p style={{ margin: 0 }}>No posts found.</p>
                </div>
              </div>
            </div>
          ) : (
            paginatedData.map((item) => (
              <div className="favoritesList shadowBox" key={item.id}>
                <div className="row">
                  <div className="col-md-5">
                    <div className="favImgThumb">
                      {item.images && item.images[0] ? (
                        <img
                          src={item.images[0]}
                          width="434"
                          height="224"
                          className="imgResponsive"
                          alt="post"
                        />
                      ) : (
                        <img
                          src={"/frontend/images/placeholder.jpg"}
                          width="434"
                          height="224"
                          className="imgResponsive"
                          alt="placeholder"
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-7 actionButtons">
                    <h2 className="bottomBorder">{item.project_name}</h2>

                    <p className="truckInfo bottomBorder">
                      {/* <span>
                        <i className="fa fa-truck" aria-hidden="true" />
                        {item.special_instruction}
                      </span>

                      <span className="space">&nbsp;</span> */}

                      <span>
                        <i className="fa fa-map-marker" aria-hidden="true" />
                        {item.address}
                      </span>
                    </p>

                    <p>{item.description}</p>

                    <Link className="button customButton01" to={`/detail/${item.id}`}>
                      View Full Detail
                    </Link>

                    {/* Optional: Edit button */}
                    <Link
                      className="button customButton01"
                      style={{ marginLeft: 10 }}
                      to={`/edit-post/${item.id}`}
                    >
                      Edit
                    </Link>
                    <button
                      type="button"
                      className="button customButton01"
                      style={{ marginLeft: 10 }}
                      onClick={() => deletePost(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}

          <div className="text-right">
            <PaginationComponent
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </section>

      {loader}
    </>
  );
};

export default MyPostList;
